import { render, staticRenderFns } from "./SaleAgentPersonDetailsView.vue?vue&type=template&id=75cd0da2&scoped=true"
import script from "./SaleAgentPersonDetailsView.vue?vue&type=script&lang=js"
export * from "./SaleAgentPersonDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd0da2",
  null
  
)

export default component.exports